// Static route table for the area; both lists are list-only (portal routes.tsx:158-173).
import { Navigate, type RouteObject } from 'react-router-dom'
import { lazyPages } from '../../app/lazyRoute'
import type { CrumbHandle } from '../../shell'

const page = lazyPages('src/features/upgradeprocess/pages.tsx', () => import('./pages'))
const crumb = (text: string): CrumbHandle => ({ crumb: () => text })

export const upgradeProcessRoutes: RouteObject[] = [
  {
    path: 'upgradeprocess',
    handle: crumb('Upgrade process'),
    children: [
      // No page of its own in the portal; the crumb lands on the first list (UPGRADE-1).
      { index: true, element: <Navigate to="tenants" replace /> },
      {
        path: 'tenants',
        handle: crumb('Tenants'),
        children: [{ index: true, lazy: page('UpgradeProcessTenantsListPage') }]
      },
      {
        path: 'releases',
        handle: crumb('Releases'),
        children: [{ index: true, lazy: page('UpgradeProcessReleasesListPage') }]
      }
    ]
  }
]
